import * as React from 'react';
import styles from './InstructionsCard.module.css';

export const InstructionsCard = () => {
  return (
    <div className={styles.cardContainer}>
      <img
        src="https://cdn.builder.io/api/v1/image/assets%2F2dcadbf627b34cb5811ae15b698d7ebb%2F875f30ec736f48e0810af015fe8afb12"
        alt="Instructions"
        className={styles.instructionsImage}
      />
    </div>
  );
};
